<template>
   <div>
    <h6 class="text-md pb-4">To download the app please select from bellow</h6>
    <div class="p-0 m-0 w-100" align="center" justify="center">
        <v-btn class="text-transform-none" width="80%" height="50" dark :href="linkToFamilyHubForAndroid" target="_blank">
          <div class="image-wrapper">
            <img class="mr-3" height="30" :src="googlePlayIcon" />
          </div>
          <div>
            <div class="text-small">GET IT ON</div>
            <div>Google Play</div>
          </div>
        </v-btn>
        <v-btn class="text-transform-none mt-6" width="80%" height="50" dark :href="linkToFamilyHubForIos" target="_blank">
          <div class="image-wrapper">
            <img class="mr-3" height="30" :src="appStoreIcon" />
          </div>
          <div>
            <span class="text-small">Download on the</span>
            <div>App Store</div>
          </div>
        </v-btn>
      </div>
   </div>
</template>

<script>
  export default {
    name: 'GetApps',
    props: {
      linkToFamilyHubForAndroid: {
        type: String,
        required: true
      },
      linkToFamilyHubForIos: {
        type: String,
        required: true
      }
    },
    data(){
      return {
        googlePlayIcon: require("@/assets/icons/google-play.png"),
        appStoreIcon: require("@/assets/icons/app-store.png")
      }
    }
  };
</script>

<style scoped>
.text-transform-none {
  text-transform: none;
}

.text-small {
  font-size: .65em;
}

.text-md {
  color: #272727;
  font-size: 20px;
  font-weight: bold;
}

.image-wrapper {
  width: 40px;
  float: left;
}
</style>
